import { useEffect } from 'react';
import {
  Text,
  Box,
  Tag,
  HStack,
  HbTooltip,
  AlertInfoIcon,
} from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { primaryLabelsSelector } from '../selectors/primary-labels.selectors';
import { hasAutoLabelsAndNoDelineationsSelector } from '../../delineation/selectors/delineation.selectors';
import { savePrimaryAbnormalities } from '../thunks/save-primary-abnormalities.thunk';
import { definitionsToAbnormalities } from '../utils/abnormalities.util';

export const AutoDiagnosticLabels: React.FC = () => {
  const dispatch = useDispatch();
  const primaryLabels = useSelector(primaryLabelsSelector);
  const hasAutoLabelsAndNoDelineation = useSelector(
    hasAutoLabelsAndNoDelineationsSelector,
  );
  useEffect(() => {
    // we want user diagnostic abnormalities to be updated automatically
    //  when primary labels change
    dispatch(
      savePrimaryAbnormalities(definitionsToAbnormalities(primaryLabels)),
    );
  }, [primaryLabels, dispatch]);

  return (
    <Box>
      <HStack>
        <Text fontSize='xs' color='neutral.400'>
          Based on beat annotation
        </Text>
        {!hasAutoLabelsAndNoDelineation && (
          <HbTooltip
            hasArrow
            label={
              <>
                <Text>Modify this diagnostic by</Text>
                <Text>editing the beat annotation</Text>
              </>
            }
          >
            <Box display='flex' justifyContent='center' alignItems='center'>
              <AlertInfoIcon />
            </Box>
          </HbTooltip>
        )}
      </HStack>
      <HStack spacing='xs' flexWrap='wrap'>
        {!hasAutoLabelsAndNoDelineation &&
          primaryLabels.map((label) => <Tag>{label.name}</Tag>)}
        {primaryLabels.length === 0 ? <Box>--</Box> : null}
      </HStack>
    </Box>
  );
};
